<div *ngIf="shouldDisplay" class="relative flex items-center justify-center h-auto" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="max-w-12xl w-full pt-0 bg-white-100 dark:bg-transparent dark:text-white h-full">
        <div (click)="changeAccordianState()">
            <p [ngClass]="panelOpenState ? 'bg-gray-100 meeting-title expand-meeting dark:bg-black dark:bg-opacity-10 pl-2 pr-2 mt-2 font-bold border-radius-5px' : ' meeting-title collapse-meeting dark:bg-black dark:bg-opacity-10 pl-2 pr-2 mt-2 font-bold border-radius-5px'" class=""
               aria-label="Decision title" tabindex="0">{{ (decisionView?.ED_DecisionNumber || decision?.ED_DecisionNumber) }} {{ (decisionView?.ED_Title || decision?.ED_Title) }}</p>
        </div>
        <div class="flex flex-wrap overflow-hidden my-2">
            <div *ngIf="panelOpenState" class="w-full overflow-hidden">
                <div class="flex flex-wrap overflow-hidden col-md-12">
                    <div class="py-2 px-1 pt-0 w-full overflow-hidden col-md-12">
                        <div class="flex flex-col w-full p-4 pt-0 filter-info">
                            <div class="row align-items-start mt-1">
                                <div class="col-md-2 col-lg-2 col-4">
                                    {{ labels?.dateOfAdoption || 'Date of adoption' }}
                                </div>
                                <div class="col-md-4 col-8">
                                    {{ ((decisionView?.ED_Date || decision?.ED_Meeting?.[0]?.ED_Date) || '') | date: 'dd MMM yyyy' }}
                                </div>
                            </div>

                            <div class="row align-items-start mt-1">
                                <div class="col-md-2 col-4">
                                    {{ labels?.plenaryMeeting || 'Plenary meeting' }}
                                </div>
                                <div class="col-md-4 col-8">
                                    {{ decisionView?.ED_Number || decision?.ED_Meeting[0].ED_Number }}
                                </div>
                            </div>

                            <div class="row align-items-start mt-1">
                                <div class="col-md-2 col-4">
                                    {{ labels?.agendaItem || 'Agenda item' }}
                                </div>
                                <div class="col-md-10 col-8">
                                    {{ decisionView?.ED_AgendaItem || decision?.ED_AgendaItem }}
                                </div>
                            </div>

                            <div class="row align-items-start  mt-1">
                                <div class="col-md-2 col-4" style="vertical-align: top;">
                                    {{ labels?.decisionText || 'Decision text' }}
                                </div>
                                <div class="col-md-10 col-8" style="white-space: pre-line">
                                    {{ decisionView?.ED_DecisionText || decision?.ED_DecisionText }}
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
